// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o52WF","input":"styles_input__28pwY"};